import { Chart } from 'chart.js'
import wordmark from '../../svg/enion-wordmark.svg'

/** Height of the logo, in pixels. */
const HEIGHT = 16

/** Room reserved above the legend for the logo, in pixels. */
export const LOGO_PADDING = HEIGHT + 12

/** Width / height of the wordmark's viewBox. */
const ASPECT = 1447 / 309

const logo = new Image()
logo.src = wordmark

/**
 * Draws the Enion wordmark in the top right corner of the chart, in the strip
 * reserved by `layout.padding.top = LOGO_PADDING`, so that screenshots of the
 * chart carry the brand without covering the bars.
 */
export const logoPlugin = {
  id: 'enionLogo',
  afterDraw (chart: Chart): void {
    if (!logo.complete || logo.naturalWidth === 0) return

    const width = HEIGHT * ASPECT
    chart.ctx.drawImage(logo, chart.chartArea.right - width, 0, width, HEIGHT)
  }
}

/** Redraws `chart` once the logo has loaded, if it had not yet when the chart was drawn. */
export const drawLogoWhenLoaded = (chart: Chart): void => {
  if (logo.complete) return
  logo.addEventListener('load', () => {
    // A chart destroyed in the meantime has no canvas.
    if (chart.canvas) chart.draw()
  }, { once: true })
}
